var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-64 2xl:w-88"
  }, [_c('div', {
    staticClass: "flex space-x-2 items-center mb-3"
  }, [_c('icon', {
    staticClass: "text-pink-600 w-5 h-5",
    attrs: {
      "name": _vm.isOwner ? 'file-propriete' : 'file'
    }
  }), _vm._v(" "), _c('info-bulle-hover', {
    attrs: {
      "name": 'filename' + _vm.file.id,
      "libelle": _vm.filename,
      "is-display-tooltip": _vm.isFilenameTooltipDisplay,
      "position": "bottom-3 left-0"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-left text-indigo-600 truncate w-60",
    on: {
      "mouseover": function ($event) {
        _vm.isFilenameTooltipDisplay = true;
      },
      "mouseleave": function ($event) {
        _vm.isFilenameTooltipDisplay = false;
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.filename) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    class: 'relative h-64 2xl:h-88 rounded-md bg-gray-200',
    on: {
      "mouseleave": function ($event) {
        _vm.hideFiligrane();
        _vm.closeMore();
      },
      "mouseenter": function ($event) {
        return _vm.showFiligrane();
      }
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.isFiligrane ? _c('div', {
    staticClass: "top-0 left-0 bg-indigo-600 bg-opacity-85 absolute w-full h-full rounded-md p-6 z-20 flex justify-center items-center cursor-default"
  }, [!_vm.isMoreDisplayed ? _c('div', {
    staticClass: "absolute right-4 top-4 p-2 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.displayMore();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "more-vertical"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isMoreDisplayed ? _c('div', {
    staticClass: "absolute right-6 top-6 flex space-x-3"
  }, [_vm.editable && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_MOVE) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.moveFile();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white transform",
    attrs: {
      "name": "foldermove"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isAdmin && _vm.editable && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_SHARE) && !_vm.$freeParticulier() ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.addMember();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "person-add"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.constants.FILE_TYPES.img.includes(_vm.file.type.toLowerCase()) || _vm.constants.FILE_TYPES.pdf.includes(_vm.file.type.toLowerCase()) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.downloadFile
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "download"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.editable && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_EDIT) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.editFile();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "edit"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.editable && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_DELETE) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.deleteFile();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "trash-2"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.constants.FILE_TYPES.img.includes(_vm.file.type.toLowerCase()) || _vm.constants.FILE_TYPES.pdf.includes(_vm.file.type.toLowerCase()) ? _c('div', {
    staticClass: "border border-pink-600 rounded-full py-1.5 px-3.5 flex justify-center text-white text-base w-max cursor-pointer transition-all duration-300 hover:bg-white hover:text-indigo-600",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openFile();
      }
    }
  }, [_vm._v("\n          Ouvrir le fichier\n        ")]) : _c('div', {
    staticClass: "border border-pink-600 rounded-full py-1.5 px-3.5 flex justify-center text-white text-base w-max cursor-pointer transition-all duration-300 hover:bg-white hover:text-indigo-600 text-center",
    on: {
      "click": _vm.downloadFile
    }
  }, [_vm._v("\n          Télécharger le fichier\n        ")])]) : _vm._e()]), _vm._v(" "), _vm.constants.FILE_TYPES.img.includes(_vm.file.type.toLowerCase()) ? _c('img', {
    staticClass: "object-cover w-full h-full rounded-md",
    attrs: {
      "src": '/depotdocs/' + _vm.file.full_path,
      "alt": ""
    }
  }) : _vm.constants.FILE_TYPES.pdf.includes(_vm.file.type.toLowerCase()) ? _c('embed', {
    staticClass: "w-64 h-64 rounded-md",
    attrs: {
      "src": '/depotdocs/' + _vm.file.full_path + '#toolbar=0&navpanes=0'
    }
  }) : _vm.constants.FILE_TYPES.doc.includes(_vm.file.type.toLowerCase()) ? _c('div', {
    staticClass: "flex items-center justify-center h-full"
  }, [_c('icon', {
    staticClass: "text-indigo-600 w-13 h-16",
    attrs: {
      "name": "file-text"
    }
  })], 1) : _vm.constants.FILE_TYPES.xls.includes(_vm.file.type.toLowerCase()) ? _c('div', {
    staticClass: "flex items-center justify-center h-full"
  }, [_c('icon', {
    staticClass: "text-teal-600 w-13 h-14",
    attrs: {
      "name": "bar-chart"
    }
  })], 1) : _vm.constants.FILE_TYPES.ppt.includes(_vm.file.type.toLowerCase()) ? _c('div', {
    staticClass: "flex items-center justify-center h-full"
  }, [_c('icon', {
    staticClass: "text-orange-600 w-16 h-15",
    attrs: {
      "name": "monitor"
    }
  })], 1) : _c('div', {
    staticClass: "flex items-center justify-center h-full"
  }, [_c('icon', {
    staticClass: "text-gray-900 transform scale-150",
    attrs: {
      "name": "file"
    }
  })], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }